import React from "react";
import Navbar from "@/components/home/Navbar";
import Footer from "@/components/home/Footer";

const SECTIONS = [
  {
    title: "Essential Cookies",
    body: "These cookies are necessary for user authentication, secure login, session management, platform security, and fraud prevention. These cookies cannot be disabled as they are required for the platform to function.",
  },
  {
    title: "Functional Cookies",
    body: "These cookies help us remember language preferences, user settings, dashboard preferences, and recently used features.",
  },
  {
    title: "Analytics Cookies",
    body: "We use analytics tools to understand page visits, feature usage, performance metrics, user interactions, and error reports. This information helps us improve NEIV.",
  },
  {
    title: "Third-Party Cookies",
    body: "Some third-party providers (such as payment gateways, analytics providers, cloud services, or authentication providers) may place cookies when you use our platform.",
  },
  {
    title: "Managing Cookies",
    body: "You can manage or disable non-essential cookies through your browser settings. Please note that disabling certain cookies may affect the functionality of the platform.",
  },
  {
    title: "Consent",
    body: "By continuing to use NEIV, you consent to the use of cookies as described in this Cookie Policy.",
  },
];

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen bg-white text-neutral-900">
      <Navbar />
      <main>
        <section className="bg-neutral-50 pb-16 pt-28 md:pb-20 md:pt-36">
          <div className="mx-auto max-w-3xl px-4 md:px-8">
            <p className="text-sm font-bold uppercase tracking-widest text-primary">Legal</p>
            <h1 className="mt-3 font-serif-display text-3xl font-medium text-neutral-900 md:text-4xl">
              Cookie Policy
            </h1>
            <p className="mt-4 text-sm text-neutral-400">Last Updated: July 27, 2026</p>
          </div>
        </section>

        <section className="bg-white py-16">
          <div className="mx-auto max-w-3xl px-4 md:px-8">
            <p className="text-base leading-relaxed text-neutral-500">
              NEIV uses cookies and similar technologies to improve your experience, provide secure access, and enhance our services.
            </p>

            <div className="mt-10 space-y-10">
              {SECTIONS.map((section) => (
                <div key={section.title}>
                  <h2 className="text-lg font-bold text-neutral-900">{section.title}</h2>
                  <p className="mt-2 leading-relaxed text-neutral-500">{section.body}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
